const URL = {
	LOGIN_INDEX: '/:partner/login',
	SING_UP: '/:partner/signup',
	LIST_MENU: '/:partner/menu',
	// LOGIN URL 
	INDEX: '',
	HOME: '/:partner',
	HOME2: '/:partner/:route/:facility',
	CONFIRMATION_SCREEN: '/:partner/paymentResponse',
	CONFIRMATION: '/paymentResponse',
	NAVIGATING: 'https://demo-permit.parkengage.com/navigating',
	SCAN_VALIDATE: '/validate',
	SCAN_TOKEN_VALIDATE: '/:partner/validate',
	TICKET_EXTEND: '/:partner/extend/:ticket_id',
	EXTEND_SUCCESS: '/:partner/extend-success',
	EXTENDSUCCESS: '/extend-success',
	TICKET: '/:partner/ticket/:ticketId',
	SEARCH: 'search-ticket',
	DETAILS: '/:partner/ticket-details',
	TICKET_DETAILS: '/ticket-details',
	INVALID: '*',
	EXTERNAL: 'https://www.npmjs.com/package/qrcode.react',
	FORFOT_PASSWORD: '/:partner/reset-password/:token_id',
	ANDROID_URL: 'https://drive.google.com/file/d/1MmZuMm2lM-vrCl-sDLv2X7NOgcBtS5mI/view?usp=share_link',
	IOS_URL: 'https://i.diawi.com/B1nJ91',
	USER_PROFILE: '/:partner/user-profile',
	SEND_EMAIL_RESET_PASSWORD: '/:partner/send-email',
	VEHICLE_LIST: '/:partner/vehicle-list',
	PAYMENT_LIST: '/:partner/payment-list',
	ADD_PAYMENT: '/:partner/add-card',
	ADD_CARD: 'add-card',
	GET_RECEIPTS: '/:partner/receipts-list',
	RECEIPTS: 'receipts-list',
	RECEIPT_DETAILLS: '/:partner/receipts-detail',
	RECEIPT_DETAIL: '/receipts-detail',
	RECEIPT: '/:partner/receipt',
	RECEIPTLIST: 'receipt',
	RECEIPT_DETAILS: '/receipt-details',
	RECEIPT_DETAILS_ROUTE: '/:partner/receipt-details',

	VEHICLE_ADD: '/:partner/vehicle-add',
	VEHICLE_EDIT: '/:partner/vehicle-edit',

	ABOUT_US: '/:partner/aboutUs',
	SERVICE_PAGE: '/:partner/servicePage',
	FACILITY_QR: 'scan-facility-qr',
	SCAN_FACILITY_QR: '/:partner/scan-facility-qr',
	EXTEND_URL: '/extend',

	// APPLEPAY TESTING  
	APPLEPAY : '/:partner/applePay',
}

export default URL
